























import { Component, Prop, Vue } from 'vue-property-decorator';
import { LocaleMessages } from 'vue-i18n';
@Component({
  name: 'app-button',
  components: {
    ButtonLoader: () => import('@/components/ButtonLoader.vue'),
  },
})
export default class Button extends Vue {
  @Prop({ type: [String, Object], default: '' }) label!:
    | string
    | LocaleMessages;
  @Prop({ type: String, default: 'button' }) type!: string;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: Boolean, default: false }) block!: boolean;
  @Prop({ type: Boolean, default: false }) outlined!: boolean;
  @Prop({ type: Boolean, default: false }) underline!: boolean;
  @Prop({ type: Boolean, default: false }) isLoading!: boolean;

  private get isCustomFont() {
    return this.$store.getters.isVox;
  }
}
